"use client";

import Link from "next/link";

import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";
import routes from "@/lib/routes";

interface AuthFormFooterProps {
  children?: React.ReactNode;
  showLegalLinks: boolean;
}

export function AuthFormFooter({
  children,
  showLegalLinks,
}: AuthFormFooterProps) {
  return (
    <div className="space-y-1 pt-0.5 sm:pt-1">
      {children}
      {showLegalLinks && (
        <p className="text-[10px] sm:text-[11px] text-ink-faint text-center leading-snug">
          By continuing, you agree to our{" "}
          <Link
            href={routes.getTerms()}
            className="text-secondary hover:underline font-medium"
            data-testid={authTestIds.TERMS_LINK}
          >
            Terms
          </Link>{" "}
          &{" "}
          <Link
            href={routes.getPrivacy()}
            className="text-secondary hover:underline font-medium"
            data-testid={authTestIds.PRIVACY_POLICY_LINK}
          >
            Privacy Policy
          </Link>
        </p>
      )}
    </div>
  );
}
